document.addEventListener('ShoptetDOMAdvancedOrderLoaded', function() {  
    $('.h1.advanced-order-suggestion').text('Doporučujeme přikoupit')
})


document.addEventListener('ShoptetDOMCartContentLoaded', function() { 
    
    $('.cart-widget-product').each(function(){
        $(this).find('.cart-widget-product-name').append('<span class="amountProduct">'+$(this).find('.cart-widget-product-amount input.amount').val()+' '+$(this).find('.cart-widget-product-unit').text()+'</span>')
    })

})

if($('.id--16, .id--17').length){
    $.get('/action/Cart/GetCartContent/?orderingProcessActive=1', function(data){   
        $('.cart-item[data-micro="cartItem"]').each(function(){
            get_id = $(this).attr('data-micro-sku')
            link = $(data.payload.content).find('.removeable[data-micro-sku="'+get_id+'"] .cart-p-image a').attr('href')
            image = $(data.payload.content).find('.removeable[data-micro-sku="'+get_id+'"] .cart-p-image img').attr('data-src').replace('related', 'detail')
            if(!$(this).find('.right').length){
                $(this).wrapInner('<div class="right"></div>')
                $(this).prepend('<div class="image"><a href="'+link+'"><img src="'+image+'" alt="'+$(this).find('a[data-testid="recapItemName"]').text()+'"></a></div>')
            }
        })
    })
    $('.cart-inner').prepend($('.cart-header'))
}

if($('.id--9').length){
    function mhProductInfoMove(){
        $('.cart-table tr').each(function(){
          var findcenazakus = $(this).find('.p-price.p-cell').html();
          var findptotal = $(this).find('.p-total');
          $(this).find('.p-name').append('<div class="avail">'+$(this).find('.p-availability').html()+'</div>')
          $(findptotal).prepend('<span class="cenazaks">'+findcenazakus+'</span>');
        })
    };
    mhProductInfoMove()
    document.addEventListener('ShoptetDOMCartContentLoaded', function () {
        mhProductInfoMove();
    });
}

if($('.id--17').length){
//    $('.cart-content>.co-contact-information .phone-form-group').after($('.form-group label[for="login"]').closest('.form-group'))
}


if($('.ordering-process').length){
    $(document).ready(function () {
        if(sessionStorage.footer) {
          $('.overall-wrapper').append(sessionStorage.footer);
          
      //    mhmove();
        } else {
          $.ajax({
            type: "GET",
            dataType: "html",
            timeout: 1e4,
            cache: !0,
            url: "/",
            success: function(e) {
                var a = shoptet.common.createDocumentFromString(e),
                t = $(a).find("#footer#footer").html();
                null !== t && ('<footer id="footer">'+t+'</footer>'), 
                $('.overall-wrapper').append('<footer id="footer">'+t+'</footer>'); //mhmove();
                sessionStorage.footer = ('<footer id="footer">'+t+'</footer>');
          
                }
            }).done(function(){
               
            });
        }
    })
}